import { BaseLoginResponse } from "../../response/seguridad/BaseLoginResponse";
import { grpcTransportProvider } from "../grpc/GrpcTransport";
import { secureStorage } from "./SecureStorageService";

class AccountService {
  /** Valida la sesión persistida (si hay token) contra `checkToken` — inyectado
   *  por cada app (hoy gRPC para Plataforma; ver `PlataformaInit.ts`), así este
   *  servicio no sabe de qué transporte viene la respuesta. */
  public loadAsync<TLoginResponse extends BaseLoginResponse>(
    checkToken: (token: string) => Promise<TLoginResponse>,
    callback: (result: TLoginResponse | null) => void,
  ): void {
    secureStorage
      .get()
      .then((token) => {
        if (!token) {
          callback(null);
          return;
        }
        checkToken(token)
          .then((result) => callback(result))
          .catch(() => callback(null));
      })
      .catch(() => {
        callback(null);
      });
  }

  public logoutAsync(
    callback: () => void,
    callbackError: (error: Error) => void,
  ): void {
    secureStorage
      .remove()
      .then(callback)
      .catch(callbackError);
  }

  /** Guarda el token de un login nuevo (contraseña o portal de Nitria) y
   *  descarta el que el transporte tenía en memoria, para que las llamadas
   *  siguientes usen el nuevo sin recargar la página. */
  public setLoginResponse(
    loginResponse: BaseLoginResponse,
    callback: () => void,
    callbackError: (error: Error) => void,
  ): void {
    secureStorage
      .set(loginResponse.token)
      .then(() => {
        grpcTransportProvider.clearToken();
        callback();
      })
      .catch(callbackError);
  }
}

export const accountService = new AccountService();
